window.jQuery(function() {
  document.addEventListener('wpcf7mailsent', function(event) {
    if (typeof gtag === 'function') {
      // 仮想ページビューイベント
      gtag('event', 'page_view', {
        page_path: '/contact-mail-sent',
        page_title: 'お問い合わせ完了',
        send_to: 'G-JRML73LG06'
      });
      // コンバージョンイベント
      gtag('event', 'conversion', {
        'send_to': 'AW-448557168/zrbACLyh6u8BEPDg8dUB'
      });
      ytag({
        "type": "yss_conversion",
        "config": {
          "yahoo_conversion_id": "1001177246",
          "yahoo_conversion_label": "ZQLhCK-X6u8BEJLw8tUB",
          "yahoo_conversion_value": "0"
        }
      });
    } else {
      console.warn('gtag is not defined');
    }
  });
});